module.exports = "https://r.nearpod.com/assets/media/image/onboarding_guide_icon-c4ef5b14f9622e2106f58939b4168435.svg";